import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';
import { RoomFlagNames } from '../../types';

export const initDrawer = createAction(
  `${reduxKey}.DAMZ_INIT_DRAWER`,
  filter => ({ filter })
);

export const fetchDrawerNext = createCallbackActionCreator(
  `${reduxKey}.DAMZ_DRAWER_FETCH`
);

export const setDrawerFilter = createAction(
  `${reduxKey}.DAMZ_DRAWER_FILTER`,
  (filter: RoomFlagNames) => ({ filter })
);

export const maybeClearRequestsCounter = createAction(
  `${reduxKey}.DAMZ_DRAWER_MAYBE_CLEAR_REQUESTS_COUNT`,
  () => ({})
);

export const clearAllDrawerStreams = createAction(
  `${reduxKey}.DAMZ_DRAWER_CLEAR_ALL_STREAMS`,
  () => ({})
);

export const reloadDrawerStream = createAction(
  `${reduxKey}.DAMZ_DRAWER_RELOAD_STREAM`,
  () => ({})
);
